import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
// KERN must come after the BUI base styles so that the token bridge takes effect.
import './styles/kern.css';
import './styles/layout.css';

/**
 * Without a stored choice Backstage follows the operating system. KERN's dark theme sits on
 * a pure black background and feels harsh as an unrequested default, so the portal starts
 * in the light theme. A choice made under Einstellungen → Darstellung still wins.
 */
try {
  if (!window.localStorage.getItem('theme')) {
    window.localStorage.setItem('theme', 'light');
  }
} catch {
  // Private mode or blocked storage: the operating system setting applies.
}

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
